import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import sr from './locales/sr.json';
import br from './locales/br.json';
import uk from './locales/uk.json';

const lang = localStorage.getItem('lang');

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    sr: {
      translation: sr,
    },
    'pt-BR': { translation: br },
    uk: {
      translation: uk,
    },
  },
  fallbackLng: lang || 'en-US',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
